import { useState } from "react";
import { useAppDispatch } from "../redux/hooks";
import { closeModal, openModal } from "../redux/uireducers/modalstrip";

function useModalStrip() {
  const [timeInterval, setTimeInterval] = useState(null); // Removed type annotation
  const dispatch = useAppDispatch();

  const showModalStrip = (modalType, message, time) => {
    if (timeInterval) {
      clearTimeout(timeInterval); // Clear any existing timeout
    }

    dispatch(openModal({ modalType, message }));

    const timeoutId = setTimeout(() => {
      dispatch(closeModal());
    }, time);

    setTimeInterval(timeoutId); // Save the timeout ID
  };

  return { showModalStrip };
}

export default useModalStrip;
